import {
  ADS_TABLE,
  ADS_TRENDS,
  OTT_TABLE,
  OTT_TRENDS,
  SEO_TABLE,
  SEO_TRENDS,
  TRUEVIEW_TABLE,
} from '../../../../../../shared/constants/analytics/contexts';
import {
  OTT_ANALYTICS_NAMESPACE,
  SEO_ANALYTICS_NAMESPACE,
  ADS_ANALYTICS_NAMESPACE,
  TRUEVIEW_ANALYTICS_NAMESPACE,
} from '../../../../../../shared/constants/shareableReports';

export const CONTEXTS = {
  [OTT_ANALYTICS_NAMESPACE]: {
    table: OTT_TABLE,
    series: OTT_TRENDS,
  },
  [SEO_ANALYTICS_NAMESPACE]: {
    table: SEO_TABLE,
    series: SEO_TRENDS,
  },
  [ADS_ANALYTICS_NAMESPACE]: {
    table: ADS_TABLE,
    series: ADS_TRENDS,
  },
  [TRUEVIEW_ANALYTICS_NAMESPACE]: {
    table: TRUEVIEW_TABLE,
  },
};
